export const config = {
    apiKey: "AIzaSyDdsp_YFAz4c6Fy0eZp48mYPAuX32xIJFE",
    authDomain: "servicescheduler-af9f2.firebaseapp.com",
    databaseURL: "https://servicescheduler-af9f2.firebaseio.com",
    projectId: "servicescheduler-af9f2",
    storageBucket: "servicescheduler-af9f2.appspot.com",
    messagingSenderId: "446576575852",
    scopes: [
        "email",
        "profile"
    ]
}